// =============================================================
// Etiquetas amigables para la vista de auditoría.
// Si una ruta no aparece en el mapa, se muestra el endpoint tal cual.
// =============================================================

// Métodos HTTP -> acción humana
const METHOD_LABELS = {
  POST: "Crear",
  PUT: "Actualizar",
  PATCH: "Modificar",
  DELETE: "Eliminar",
};

export const methodLabel = (method) => METHOD_LABELS[method] || method || "-";

// Mapa de prefijos de ruta -> nombre de módulo amigable.
// Se evalúa por "ruta más larga primero" para que rutas específicas
// ganen sobre las genéricas.
const ROUTE_LABELS = [
  // Siniestros viales
  ["/api/v1/siniestros-viales/reportes", "Siniestros viales · Reportes"],
  ["/api/v1/siniestros-viales/investigaciones", "Siniestros viales · Investigaciones"],
  ["/api/v1/siniestros-viales/documentos-procesos-juridicos", "Siniestros viales · Procesos jurídicos"],
  ["/api/v1/siniestros-viales/documentos-provisiones-legales", "Siniestros viales · Provisiones legales"],
  ["/api/v1/siniestros-viales/documentos", "Siniestros viales · Documentos"],
  ["/api/v1/siniestros-viales/costos-siniestros-juridicos", "Siniestros viales · Costos jurídicos"],
  ["/api/v1/siniestros-viales/divulgacion-lecciones", "Siniestros viales · Divulgación de lecciones"],

  // Funcionamiento
  ["/api/v1/funcionamiento/indicadores", "Funcionamiento · Indicadores"],
  ["/api/v1/funcionamiento/informes-mensuales-pdf", "Funcionamiento · Informes mensuales PDF"],
  ["/api/v1/funcionamiento/lista-rutas-trabajo", "Funcionamiento · Rutas de trabajo"],
  ["/api/v1/funcionamiento/control-horario-personal", "Funcionamiento · Control horario"],
  ["/api/v1/funcionamiento/certificado-limite-velocidad", "Funcionamiento · Certificado de límite de velocidad"],

  // Documentos administrativos
  ["/api/v1/documentos-admin-varios", "Documentos administrativos · Varios"],
  ["/api/v1/documentos-admin", "Documentos administrativos"],

  // Otros módulos
  ["/api/v1/matriz-riesgo", "Matriz de riesgo"],
  ["/api/v1/plan-trabajo-capacitacion", "Plan de trabajo y capacitación"],
  ["/api/v1/inspeccion-vehiculos", "Inspección de vehículos"],
  ["/api/v1/mantenimiento", "Mantenimiento"],
  ["/api/v1/gestion-velocidad", "Gestión de velocidad"],
  ["/api/v1/informes-mensuales", "Informes mensuales"],
  ["/api/v1/infracciones", "Infracciones"],
  ["/api/v1/llamados-atencion", "Llamados de atención"],
  ["/api/v1/indicadores", "Indicadores"],
  ["/api/v1/auditoria", "Logs de auditoría"],
  ["/api/v1/dashboard", "Dashboard"],
  ["/api/v3/alertas", "Alertas"],
  ["/api/v2/vehiculos", "Vehículos"],
  ["/api/v2/consultar_compania", "Compañía"],
];

// Pre-ordenar por longitud descendente para que el match más
// específico siempre gane.
const SORTED_ROUTES = [...ROUTE_LABELS].sort(
  (a, b) => b[0].length - a[0].length
);

/**
 * Devuelve una etiqueta amigable para un endpoint dado.
 * Si no se encuentra coincidencia, retorna el endpoint original.
 */
export const endpointLabel = (endpoint) => {
  if (!endpoint) return "-";
  // Quitar query string para hacer match
  const path = String(endpoint).split("?")[0];
  for (const [prefix, label] of SORTED_ROUTES) {
    if (path === prefix || path.startsWith(prefix + "/")) {
      return label;
    }
  }
  return endpoint;
};
